import { useAutoReloadCheck } from './useAutoReloadCheck'
import ConfirmDialog from '../ConfirmDialog'
import { useTranslation } from 'react-i18next'

const AutoReloadProvider: React.FC = () => {
  const { show_reload_dialog, handleReload, handleCancel } = useAutoReloadCheck()
  const { t } = useTranslation()

  return <ConfirmDialog
    open={show_reload_dialog}
    onClose={handleCancel}
    action={handleReload}
    message={t('general.long_session_message')}
    ok_text={t('general.reload')}
    cancel_text={t('general.later')}
    ok_color="primary"
  />
}
export default AutoReloadProvider
